<template>
    <v-alert v-if="error" color="red" elevation="2" border="left" colored-border class="mx-auto mt-16" min-width="60%">
        <div class="d-flex align-center" style="gap: 12px">
            <div class="flex-grow-1">
                <div v-if="error === 'configuration'">
                    <div>Your SAML integration appears to be improperly configured.</div>
                    <div>Coroot expects to receive the following attributes from your Identity Provider: <b>Email</b>, <b>FirstName</b>, and <b>LastName</b>.</div>
                </div>
                <div v-else>An error occurred. The Coroot team has already been notified. Please try again later.</div>
            </div>
            <v-btn :to="{query: {error: undefined}}" color="primary">refresh</v-btn>
        </div>
    </v-alert>
</template>
<script>
export default {
    props: {
        workspaceId: String,
    },

    computed: {
        error() {
            return this.$route.query.error;
        }
    },

    mounted() {
        if (this.error) {
            return;
        }
        this.get();
    },

    watch: {
        error(v) {
            if (!v) {
                this.get();
            }
        },
    },

    methods: {
        get() {
            this.$api.getWorkspaceSamlAuthenticationRequest(this.workspaceId, data => {
                window.location.href = data;
            })
        }
    },
}
</script>

<style scoped>

</style>
